import { v4 as uuidv4 } from 'uuid';
import template1 from './1/component';

const templates = {
	1: template1,
};

export default templates;
export function BreadcrumbGroup(templateId = 1) {
	return templates[templateId]();
}

export const breadCrumbReference = () => {
	return {
		componentGroup: 'BreadcrumbGroup',
		componentName: 'FlexLayoutRow',
		componentId: uuidv4(),
	};
};
